import { createContext } from 'react';

import { ActionCableProviderContextType } from './ActionCableProviderContext.types';

export const ActionCableProviderContext = createContext<ActionCableProviderContextType>(
  undefined as unknown as ActionCableProviderContextType,
);
